import { OrganizationMapper } from "../organization/organization.mapper";
import { Company } from "./company.model";

export class CompanyMapper {
  public static map(data: any): Company {
    if (!data) {
      return;
    }

    return new Company(
      data.id,
      data.name,
      data.ref,
      OrganizationMapper.map(data.organization),
    );
  }
}
